import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { DIC } from '../../../dic';
import { GN } from '../../../../gn';
import * as moment from 'moment';
import * as jsPDF from 'jspdf'
// import * as html2canvas from 'html2canvas';
declare var html2canvas;


/**
 * Generated class for the PrintreportPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-printreport',
  templateUrl: 'printreport.html',
})
export class PrintreportPage {

  nalogid: any
  object: any
  loadingData: boolean = false
  nalogdetali = []
  vozacbroj1 = ''
  job1 = ''
  weapon1 = ''
  pocetokruta: any
  datumizrabotka: any
  registracija = ''
  model = ''
  nalog = ''
  vozacbroj2 = ''
  job2 = ''
  weapon2 = ''
  vozacbroj3 = ''
  job3 = ''
  weapon3 = ''
  vozacbroj4 = ''
  job4 = ''
  weapon4 = ''

  par = []
  nepar = []

  proba = []
  krajna = []
  pred: any


  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public loadingCtrl: LoadingController, public alertCtrl: AlertController) {
    this.nalogid = this.navParams.get('did')
    this.pred = this.navParams.get('pred')
    // this.object = this.navParams.get('drn')
    // this.vozacbroj1 = this.object.sofer
    console.log(this.nalogid, 'dali ke mi dades id')

    // console.log(this.object, 'dali ke mi dades obj')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PrintreportPage');
    this.loadData()
    // console.log(this.krajna, 'aj da vidma krajna')

  }

  loadData() {
    this.loadingData = true
    var _that = this

    this.gn._Post('/api/gn/getDetaliNalog', { id: this.gn.crypt(this.nalogid), pred: this.gn.crypt(this.pred) }, function (_data) {
      console.log(_data, 'daj da vidam data')
      for (let i = 0; i < _data.length; i++) {
        _that.vozacbroj1 = _data[0].fullname1
        _that.pocetokruta = moment(_data[0].pocetokruta).format(_that.gn.user.DFormat) + ' ' + moment(_data[0].pocetokruta).format(_that.gn.user.TFormat)
        _that.datumizrabotka = moment(_data[0].izrabotka).format(_that.gn.user.DFormat) + ' ' + moment(_data[0].izrabotka).format(_that.gn.user.TFormat)
        _that.registracija = '(' + _data[0].code + ')' + ' ' + _data[0].registration
        _that.model = _data[0].model
        _that.nalog = _that.gn.clientsettings.personalroutenumbering == '1' ? _data[0].routenum : _data[0].nalogbroj//_data[0].nalogname
        _that.job1 = _data[0].jobname1
        _that.weapon1 = _data[0].weaponserial1
        _that.vozacbroj2 = _data[0].fullname2
        _that.job2 = _data[0].jobname2
        _that.weapon2 = _data[0].weaponserial2
        _that.vozacbroj3 = _data[0].fullname3
        _that.job3 = _data[0].jobname3
        _that.weapon3 = _data[0].weaponserial3
        _that.vozacbroj4 = _data[0].fullname4
        _that.job4 = _data[0].jobname4
        _that.weapon4 = _data[0].weaponserial4

        if (_data[i].description == null) {
          _data[i].description = ''
        }

        if (i % 2 == 0) {
          _that.par.push(_data[i])
        }
        else {
          _that.nepar.push(_data[i])
        }
      }

      for (let j = 0; j < _that.par.length; j++) {
        for (let c = 0; c < _that.nepar.length; c++) {
          // debugger
          if (c == j) {
            _that.krajna.push({
              od: _that.par[j].name,
              od1: _that.par[j].description.indexOf(',') != -1 ? _that.par[j].description.substring(0, _that.par[j].description.lastIndexOf(', ')) : _that.par[j].description.substring(_that.par[j].description.lastIndexOf(', ') + 1),
              grad1: _that.par[j].description.indexOf(',') != -1 ? _that.par[j].description.substring(_that.par[j].description.lastIndexOf(', ') + 1) : '',
              do: _that.nepar[c].name,
              do1: _that.nepar[c].description.indexOf(',') != -1 ? _that.nepar[c].description.substring(0, _that.nepar[c].description.lastIndexOf(', ')) : _that.nepar[c].description.substring(_that.nepar[c].description.lastIndexOf(', ') + 1),
              grad2: _that.nepar[c].description.indexOf(',') != -1 ? _that.nepar[c].description.substring(_that.nepar[c].description.lastIndexOf(', ') + 1) : '',
            })
          }
        }

      }
      _that.nalogdetali = _data
      _that.loadingData = false
    })
  }

  getPriv(key) {
    var num;
    for (var i = 0; i < this.gn.priv.length; i++) {
      if (this.gn.user.RoleId == 3) {
        if (this.gn.user.UserId == this.gn.priv[i].userid) {
          return this.gn.priv[i][key];
        }
      } else {
        return true;
      }
    }
  }



  exportToPdf(_viaEmail = false, _email = '', _xlsname = '') {
    if (this.getPriv('exportpdf') == false) {
      return false;
    }
    var loader = this.loadingCtrl.create({
      content: this.dic.l["PleaseWaitPDF"],
      // duration: 3000
    });
    var _that = this
    // console.log((<HTMLElement>document.getElementById("printnalog").getElementsByClassName('scroll-content')[0]), 'daj da go vidam nalogot')
    loader.present().then(() => {
      const div = (<HTMLElement>document.getElementById("printnalog"))
      div.style.overflow = 'visible'
      div.style.paddingBottom = '200px'

      // var _h = div.getElementsByClassName('scroll-content')[0].scrollHeight;
      const options = {
        pagesplit: true,
        background: "white",
        height: div.scrollHeight + 200,
        width: div.clientWidth
      };
      html2canvas(div, options).then((canvas) => {

        //Initialize JSPDF
        var doc = new jsPDF("p", "mm", "a4", true);

        var marginTopBottom = 10
        var marginLefgtRight = 5
        var pHeight = 297.0
        var pWidth = 210.0
        pWidth = (pWidth - (marginLefgtRight * 2)) * 1.0
        pHeight = (pHeight - (marginTopBottom * 2)) * 1.0
        // let imgData = canvas.toDataURL("image/jpg");
        // var a = document.createElement('a');          
        // a.href = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
        // a.download = 'somefilename.jpg';
        // a.click();



        // com
        // window.open(canvas.toDataURL("image/png"), '_blank');

        var _k = pWidth / canvas.width
        var imgWidth = canvas.width * _k
        var imgHeight = canvas.height * _k

        var pgs = imgHeight / pHeight
        var pages = parseInt((imgHeight / pHeight) + '');//Math.round(imgHeight / pHeight)
        // console.log('height', imgHeight, pHeight, imgHeight % pHeight)
        if (imgHeight % pHeight != 0) {
          pages = pages + 1
        }
        console.log(imgHeight, pHeight, pages)
        var imgCutH = canvas.height / pgs
        // console.log('canvas.width: '+canvas.width, 'canvas.heigh: '+canvas.height)
        // console.log('pgs: '+imgCutH, 'pHeight: ', pHeight, 'pWidth: ', pWidth)
        var tpmY = 0
        for (var i = 0; i < pages; i++) {
          var ctx = canvas.getContext("2d");
          var cutH = imgCutH
          if (imgCutH + tpmY > canvas.height) {
            cutH = canvas.height - tpmY
          }

          var iData = ctx.getImageData(0, tpmY, canvas.width, cutH);


          var tmpCanvas = document.createElement('canvas');
          tmpCanvas.width = canvas.width;
          tmpCanvas.height = imgCutH;
          var tmpContext = tmpCanvas.getContext('2d');
          tmpContext.beginPath();
          tmpContext.rect(0, 0, canvas.width, imgCutH);
          tmpContext.fillStyle = "white";
          tmpContext.fill();

          tmpContext.rect(0, 0, pWidth, pHeight);
          tmpContext.fillStyle = "white";
          tmpContext.fill();

          tmpContext.putImageData(iData, 0, 0);
          // console.log(canvas.width, imgCutH)
          // var a = document.createElement('a');          
          // a.href = tmpCanvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
          // a.download = 'somefilename.jpg';
          // a.click();



          doc.addImage(tmpCanvas.toDataURL("image/jpeg"), 'JPEG', marginTopBottom, marginLefgtRight, pWidth, pHeight);
          if (i < pages - 1) {
            doc.addPage();
          }
          tpmY = tpmY + imgCutH
        }



        var fName = this.nalog == '' ? this.registracija : this.nalog;

        // if (this.selectedRepMenu.indexOf('CustomizedReport') != -1) {
        //   var _rgnum = 3;
        //   if (this.gn.clientsettings.allowedfm == '1') _rgnum += 1;
        //   for (var i = 0; i < this.Groups[_rgnum].menus.length; i++) {
        //     if (this.Groups[_rgnum].menus[i].key == this.selectedRepMenu) {
        //       fName = this.Groups[_rgnum].menus[i].title
        //       fName = fName.replace(/ /g, '_')
        //     }
        //   }
        // } else {
        //   fName = _that.dic.l[_that.selectedRepMenu]
        //   fName = fName.replace(/ /g, '_')
        // }

        // REMOVE GPORAN

        if (_viaEmail == false) {
          doc.save(fName + ".pdf");
        } else {
          var _dataPDF = doc.output('datauristring');
          // // console.log(_dataPDF)
          // console.log(_dataPDF.length)
          // var aa =_that.gn.crypt(LZString.compress(_dataPDF))

          // console.log(aa.length)
          _that.gn._Post('/api/gn/sendreportviaemailPDF', { name: _that.gn.crypt(fName), eml: _that.gn.crypt(_email), data: _dataPDF, lng: _that.gn.crypt(_that.dic.Lang), xls: _that.gn.crypt(_xlsname) }, function (_data2) {
            // console.log(_data2)

            _that.gn.xlsFunctionToServer = false
            _that.gn.xlsFunctionCallback = null
          })
        }
        loader.dismiss()
        div.style.overflow = ''
        div.style.paddingBottom = ''



      });
    });
  }

  sendReportViaEmail() {
    var _that = this
    var prompt = this.alertCtrl.create({
      title: this.dic.l["email"],
      message: this.dic.l["enteremail"],
      inputs: [
        {
          name: 'eml',
          placeholder: this.dic.l["email"]
        },
      ],
      buttons: [
        {
          text: this.dic.l['cancel'],
          handler: data => {
          }
        },
        {
          text: this.dic.l["send"],
          handler: data => {
            // console.log('Saved clicked');
            if (data.eml != '') {
              _that.gn.xlsFunctionToServer = true
              _that.gn.xlsFunctionCallback = function (_xls) {
                _that.exportToPdf(true, data.eml, _xls)
              }
              _that.gn.xlsFunction()
            }
          }
        }
      ]
    });
    prompt.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/routing/routebank/reportorderbank/printreport.ts